import { render, staticRenderFns } from "./WebsiteBanner.vue?vue&type=template&id=f336a826&scoped=true&"
import script from "./WebsiteBanner.vue?vue&type=script&lang=js&"
export * from "./WebsiteBanner.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteBanner.vue?vue&type=style&index=0&id=f336a826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f336a826",
  null
  
)

export default component.exports